/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const SITE_SERIE_RESPONSE = {
	sites: [
		{
			siteId: 9,
			siteName: "Scotland",
			domainName: "core-ntt-icc",
			regionName: "UK",
			latitude: "55.952",
			longitude: "-3.115",
			onboarded: "Active",
			lastCheck: null
		},
		{
			siteId: 10,
			siteName: "Boston",
			domainName: "core-ntt-icc",
			regionName: "ISONE",
			latitude: "41.6688",
			longitude: "-70.2962",
			onboarded: "Active",
			lastCheck: null
		}
	]
};

export const METRIC_OVERVIEW_RESPONSE = {
	sitesCount: 2,
	s1s2TotalSites: 24693.8612,
	winSites: 4946.0,
	sites: [
		{
			siteId: 9,
			year: 2026,
			aggregatedMetrics: {
				pue: {
					aa: 0.5137154761666667,
					yt: 1.3704,
					ytd: 0.5137154761666667
				},
				cue: {
					aa: 8.1190475e-4,
					yt: 0.0033,
					ytd: 8.1190475e-4
				},
				edc: {
					aa: 921431.0,
					yt: 921431.0,
					ytd: 921431.0
				},
				wue: {
					aa: 2.4102845238333335,
					yt: 0.708,
					ytd: 2.4102845238333335
				},
				total_co2_emissions: {
					aa: 2243.6867,
					yt: 2243.6867,
					ytd: 2243.6867
				},
				win: {
					aa: 476.0,
					yt: 476.0,
					ytd: 476.0
				}
			},
			lastUpdatedMonth: 4
		},
		{
			siteId: 10,
			year: 2026,
			aggregatedMetrics: {
				pue: {
					aa: 0.51858571425,
					yt: null,
					ytd: 0.51858571425
				},
				cue: {
					aa: 8.226190833333334e-4,
					yt: null,
					ytd: 8.226190833333334e-4
				},
				edc: {
					aa: null,
					yt: null,
					ytd: null
				},
				wue: {
					aa: 2.4121678571666667,
					yt: null,
					ytd: 2.4121678571666667
				},
				total_co2_emissions: {
					aa: null,
					yt: null,
					ytd: null
				},
				win: {
					aa: null,
					yt: null,
					ytd: null
				}
			},
			lastUpdatedMonth: 4
		}
	]
};

export const SITE_METRIC_DATA_RESPONSE: Record<number, unknown[]> = {
	9: [
		{
			siteId: 9,
			metricId: 1,
			unitType: "",
			widgetType: "key_metric",
			metrics: {
				Unit: "",
				data: [
					{ label: "2025-10-01T00:00:00", value: 1.1765 },
					{ label: "2025-11-01T00:00:00", value: 1.1765 },
					{ label: "2025-12-01T00:00:00", value: 1.1765 },
					{ label: "2026-01-01T00:00:00", value: 1.1765 },
					{ label: "2026-02-01T00:00:00", value: 1.1765 },
					{ label: "2026-03-29T00:00:00", value: 1.183 }
				],
				Total: "1.18",
				annualAvg: "1.18",
				metricName: "Power Usage Effectiveness (PUE)"
			}
		},
		{
			siteId: 9,
			metricId: 2,
			unitType: "",
			widgetType: "key_metric",
			metrics: {
				Unit: "",
				data: [
					{ label: "2025-10-01T00:00:00", value: 0.0157 },
					{ label: "2025-11-01T00:00:00", value: 0.0157 },
					{ label: "2025-12-01T00:00:00", value: 0.0158 },
					{ label: "2026-01-01T00:00:00", value: 0.0158 },
					{ label: "2026-02-01T00:00:00", value: 0.0158 },
					{ label: "2026-03-29T00:00:00", value: 0.0161 }
				],
				Total: "0.02",
				annualAvg: "0.02",
				metricName: "Carbon Usage Effectiveness (CUE)"
			}
		},
		{
			siteId: 9,
			metricId: 3,
			unitType: "",
			widgetType: "key_metric",
			metrics: {
				Unit: "",
				data: [
					{ label: "2025-10-01T00:00:00", value: 7.02 },
					{ label: "2025-11-01T00:00:00", value: 7.04 },
					{ label: "2025-12-01T00:00:00", value: 7.05 },
					{ label: "2026-01-01T00:00:00", value: 7.06 },
					{ label: "2026-02-01T00:00:00", value: 7.0588 },
					{ label: "2026-03-29T00:00:00", value: 7.08 }
				],
				Total: "7.05",
				annualAvg: "7.05",
				metricName: "Water Usage Effectiveness (WUE)"
			}
		},
		{
			siteId: 9,
			metricId: 4,
			unitType: "kWh",
			widgetType: "key_metric",
			metrics: {
				Unit: "kWh",
				data: [
					{ label: "2025-10-01T00:00:00", value: 988000.0 },
					{ label: "2025-11-01T00:00:00", value: 993000.0 },
					{ label: "2025-12-01T00:00:00", value: 997000.0 },
					{ label: "2026-01-01T00:00:00", value: 999000.0 },
					{ label: "2026-02-01T00:00:00", value: 1000000.0 },
					{ label: "2026-03-29T00:00:00", value: 109500.72 }
				],
				Total: "5086500",
				annualAvg: "847750",
				metricName: "Energy Consumption (EDC)"
			}
		},
		{
			siteId: 9,
			metricId: 5,
			unitType: "kgCO2e",
			widgetType: "key_metric",
			metrics: {
				Unit: "kgCO2e",
				data: [
					{ label: "2025-10-01T00:00:00", value: 13208.5 },
					{ label: "2025-11-01T00:00:00", value: 13295.7 },
					{ label: "2025-12-01T00:00:00", value: 13390.5 },
					{ label: "2026-01-01T00:00:00", value: 13404.4 },
					{ label: "2026-02-01T00:00:00", value: 13416.8 },
					{ label: "2026-03-29T00:00:00", value: 1470.0 }
				],
				Total: "68185.9",
				annualAvg: "11364.32",
				metricName: "Total Emission (Scope 1 + Scope 2)"
			}
		},
		{
			siteId: 9,
			metricId: 6,
			unitType: "m3",
			widgetType: "key_metric",
			metrics: {
				Unit: "m3",
				data: [
					{ label: "2025-10-01T00:00:00", value: 5928.0 },
					{ label: "2025-11-01T00:00:00", value: 5958.0 },
					{ label: "2025-12-01T00:00:00", value: 5982.0 },
					{ label: "2026-01-01T00:00:00", value: 5994.0 },
					{ label: "2026-02-01T00:00:00", value: 6000.0 },
					{ label: "2026-03-29T00:00:00", value: 657.0 }
				],
				Total: "30519",
				annualAvg: "5086.5",
				metricName: "Water Consumption (WIN)"
			}
		},
		{
			siteId: 9,
			metricId: 7,
			unitType: "kWh",
			widgetType: "point_chart",
			metrics: {
				Unit: "kWh",
				data: [
					{ label: "2025-10-01T00:00:00", value: 988000.0 },
					{ label: "2025-11-01T00:00:00", value: 993000.0 },
					{ label: "2025-12-01T00:00:00", value: 997000.0 },
					{ label: "2026-01-01T00:00:00", value: 999000.0 },
					{ label: "2026-02-01T00:00:00", value: 1000000.0 },
					{ label: "2026-03-29T00:00:00", value: 109500.0 }
				],
				Total: "5086500",
				annualAvg: "847750",
				metricName: "Energy Consumption (EDC)"
			}
		},
		{
			siteId: 9,
			metricId: 8,
			unitType: "kWh",
			widgetType: "point_chart",
			metrics: {
				Unit: "kWh",
				data: [
					{ label: "2025-10-01T00:00:00", value: 745940.0 },
					{ label: "2025-11-01T00:00:00", value: 749412.9 },
					{ label: "2025-12-01T00:00:00", value: 753233.5 },
					{ label: "2026-01-01T00:00:00", value: 754944.3 },
					{ label: "2026-02-01T00:00:00", value: 755800.0 },
					{ label: "2026-03-29T00:00:00", value: 81885.0 }
				],
				Total: "3841215.7",
				annualAvg: "640202.62",
				metricName: "Renewable Energy From Guarantees of Origin (ERES-GOO)"
			}
		},
		{
			siteId: 9,
			metricId: 9,
			unitType: "kgCO2e",
			widgetType: "point_chart",
			metrics: {
				Unit: "kgCO2e",
				data: [
					{ label: "2025-10-01T00:00:00", value: 11891.0 },
					{ label: "2025-11-01T00:00:00", value: 11972.9 },
					{ label: "2025-12-01T00:00:00", value: 12065.1 },
					{ label: "2026-01-01T00:00:00", value: 12076.2 },
					{ label: "2026-02-01T00:00:00", value: 12086.0 },
					{ label: "2026-03-29T00:00:00", value: 1323.0 }
				],
				Total: "61414.2",
				annualAvg: "10235.7",
				metricName: "Scope 2 - Location Based Emission (LBE)"
			}
		},
		{
			siteId: 9,
			metricId: 10,
			unitType: "kWh",
			widgetType: "bar_chart",
			metrics: {
				Unit: "kWh",
				data: [
					{ label: "2025-10-01T00:00:00", value: 839800.0 },
					{ label: "2025-11-01T00:00:00", value: 844100.0 },
					{ label: "2025-12-01T00:00:00", value: 847500.0 },
					{ label: "2026-01-01T00:00:00", value: 849100.0 },
					{ label: "2026-02-01T00:00:00", value: 850000.0 },
					{ label: "2026-03-29T00:00:00", value: 92700.0 }
				],
				Total: "4323200",
				annualAvg: "720533.33",
				metricName: "ICT Equipment Energy Consumption (EIT)"
			}
		},
		{
			siteId: 9,
			metricId: 11,
			unitType: "kWh",
			widgetType: "bar_chart",
			metrics: {
				Unit: "kWh",
				data: [
					{ label: "2025-10-01T00:00:00", value: 148200.0 },
					{ label: "2025-11-01T00:00:00", value: 148950.0 },
					{ label: "2025-12-01T00:00:00", value: 149550.0 },
					{ label: "2026-01-01T00:00:00", value: 149850.0 },
					{ label: "2026-02-01T00:00:00", value: 150000.0 },
					{ label: "2026-03-29T00:00:00", value: 19650.0 }
				],
				Total: "766200",
				annualAvg: "127700",
				metricName: "Electricity Used by Cooling Systems (ECooling)"
			}
		},
		{
			siteId: 9,
			metricId: 12,
			unitType: "kWh",
			widgetType: "bar_chart",
			metrics: {
				Unit: "kWh",
				data: [
					{ label: "2025-10-01T00:00:00", value: 988000.0 },
					{ label: "2025-11-01T00:00:00", value: 993000.0 },
					{ label: "2025-12-01T00:00:00", value: 997000.0 },
					{ label: "2026-01-01T00:00:00", value: 999000.0 },
					{ label: "2026-02-01T00:00:00", value: 1000000.0 },
					{ label: "2026-03-29T00:00:00", value: 109500.0 }
				],
				Total: "5086500",
				annualAvg: "847750",
				metricName: "Energy Consumption (EDC)"
			}
		}
	],
	10: []
};
